export default {
  error: err => {
    // eslint-disable-next-line no-console
    console.error(err)
  },
}
